<template>

    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
   
    </section>

    <section class="datatableclass">
      <div>
        <DownloadPdf :tabledata="tabledata" :opssection1="opssection1"/>
      </div>
    </section>
   
    
    <FooterPage />

</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import DownloadPdf from '@/components/DownloadPdf.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import "@/plugins/chart.js"

import axios from 'axios';


export default {
  name: 'AboutView',
  props: {
        msg: String
    },
  components: {
  NavBar, FooterPage, DownloadPdf
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  opssection1: '',

  tabledata: []
  }
},
methods: {

},
async mounted() {

await axios.get('allpagespv/exploration').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
          console.log(error)
        })
  
  await axios.get('getsilverdemandgraphdata/exploration').then(
    response => { 
      this.opssilverdemandgraphlabels = response.data.glabels
      this.opssilverdemandgraphdata = response.data.gdata
  })
  .catch((error) => {
      console.log(error)
  }) 
    

  //------------mandate table info---------------
await axios.get('getuploadededfile/exploration').then(
    response => {
        this.tabledata = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Operations products page Cards ---------------
await axios.get('getopspageexploration/').then(
    response => { 
    this.opssection1 = response.data[0].opssection1
    console.log(this.opssection1)
  })
  .catch((error) => {
      console.log(error)
    }) 
}
}
</script>

<style scoped>

.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

/* Move the background and make it larger. 
/* Media Query CSS*/
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
  .datadiv0 {
    font-size: 12px;
    margin-top: 300px;
    width: 100%;
  }
  
  .datadiv1 {
    font-size: 12px;
    margin-top: 300px;
    width: 100%;
  }

  .datatableclass {
    margin-bottom: 200px;
  }
  .datatableclass {
    margin-bottom: 100px;
    margin-top: 300px;
  }

  @-moz-document url-prefix() {
 
  }
     
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
  .datadiv0 {
    font-size: 12px;
    margin-top: 300px;
    width: 100%;
  }
  
  .datadiv1 {
    font-size: 12px;
    margin-top: 300px;
    width: 100%;
  }

  .datatableclass {
    margin-bottom: 100px;
    margin-top: 300px;
  }
  @-moz-document url-prefix() {
   
  }


}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .txtdata {
    margin-bottom: 30px;
    width: 900px;
    padding-right: 10px;
  }
  .datadiv0 {
    font-size: 12px;
    margin-top: 300px;
    width: 40%;
  }
  
  .datadiv1 {
    font-size: 12px;
    margin-top: 300px;
    width: 60%;
  }
  .datatableclass {
    margin-bottom: 10px;
  }

  @-moz-document url-prefix() {
  
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .txtdata {
    margin-bottom: 30px;
    width: 800px;
    padding-right: 10px;
  }
   .datatableclass {
    margin-bottom: 200px;
    margin-top: 300px;
    padding-top: 100px;
    padding-bottom: 100px;
  }

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .txtdata {
    margin-bottom: 100px;
    width: 900px;
    padding-right: 10px;
  }
.datatableclass {
  margin-top: 200px;
}
} 
</style>
